module.exports = __webpack_public_path__ + "static/media/SplashImage.15f9272a.png";